import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { getArticleSchema, getBreadcrumbSchema } from '@/utils/seoJsonLd';

const articleSections = [
  {
    title: 'Czym są zdjęcia QC i dlaczego są tak ważne?',
    content: `Zdjęcia QC (Quality Control) to fotografie kontrolne wykonywane przez agenta zakupowego po otrzymaniu produktu od sprzedawcy, ale przed wysyłką do Ciebie. To Twoja jedyna okazja, aby zobaczyć rzeczywisty stan produktu przed jego zapakowaniem i wysłaniem do Polski.

Dlaczego zdjęcia QC są kluczowe? Wyobraź sobie, że zamawiasz sneakersy za 300 PLN. Na zdjęciach sprzedawcy wyglądają idealnie — czyste szwy, idealne logo, doskonały kolor. Jednak rzeczywistość może być zupełnie inna. Zdjęcia QC pokazują Ci prawdę: czy szwy są równe, czy logo jest prawidłowo umieszczone, czy kolor zgadza się z opisem, i czy materiał wygląda tak, jak oczekiwałeś.

Dzięki zdjęciom QC możesz podjąć świadomą decyzję: zaakceptować produkt i wysłać go do Polski, poprosić o wymianę na lepszy egzemplarz, lub zrezygnować z zakupu i odzyskać pieniądze. Bez zdjęć QC kupujesz w ciemno — a to ryzyko, którego lepiej unikać.`,
  },
  {
    title: 'Jak analizować zdjęcia QC — krok po kroku',
    content: `Oto szczegółowy przewodnik, jak czytać zdjęcia QC jak profesjonalista. Podzieliliśmy proces na 5 kluczowych kroków:

Krok 1: Ogólny wygląd produktu. Rozpocznij od ogólnej oceny — czy produkt wygląda tak, jak na zdjęciach sprzedawcy? Zwróć uwagę na proporcje, kształt i ogólne wrażenie wizualne. Jeśli coś od razu rzuca Ci się w oczy jako niepokojące, to prawdopodobnie masz rację.

Krok 2: Sprawdzenie logo i oznaczeń. W przypadku markowych produktów, logo jest jednym z najczęstszych elementów, które mogą odbiegać od oryginału. Sprawdź, czy logo jest prawidłowo umieszczone, czy rozmiar i czcionka są odpowiednie, oraz czy nie ma widocznych niedoskonałości w nadruku lub haftowaniu.

Krok 3: Kontrola szwów i wykończenia. Przyjrzyj się dokładnie wszystkim szwom — powinny być równe, proste i bez luźnych nitek. Sprawdź łączenia materiałów, zamki błyskawiczne, guziki i inne elementy wykończeniowe. Nierówne szwy to jeden z najczęstszych problemów jakościowych.

Krok 4: Kolor i materiał. Porównaj kolor produktu ze zdjęciami sprzedawcy. Pamiętaj, że oświetlenie w magazynie agenta może różnić się od oświetlenia w studio sprzedawcy, więc małe różnice są normalne. Jeśli jednak kolor znacząco odbiega od oczekiwań, rozważ prośbę o dodatkowe zdjęcia.

Krok 5: Pomiar i rozmiar. Jeśli agent udostępnia zdjęcia z miarką, porównaj wymiary produktu z tabelą rozmiarów sprzedawcy. Dotyczy to szczególnie ubrań i butów — nawet centymetr różnicy może sprawić, że produkt nie będzie pasował.`,
  },
  {
    title: 'Czerwone flagi — na co szczególnie uważać',
    content: `Podczas analizy zdjęć QC zwracaj szczególną uwagę na następujące sygnały ostrzegawcze, które mogą świadczyć o niskiej jakości produktu:

1. Nierówne lub krzywe szwy — to podstawowy wskaźnik niskiej jakości wykonania. Jeśli szwy są krzywe, produkt prawdopodobnie został wykonany niedbale i może szybko się zniszczyć.

2. Widoczne plamy lub zabrudzenia — każdy nowy produkt powinien być czysty i wolny od wad fabrycznych. Plamy, przebarwienia lub ślady użytkowania to sygnał, że produkt nie jest nowy lub był nieprawidłowo przechowywany.

3. Niezgodność kolorystyczna — jeśli kolor produktu na zdjęciach QC radykalnie różni się od zdjęć sprzedawcy (nie chodzi tu o subtelne różnice wynikające z oświetlenia), może to oznaczać, że otrzymałeś inny wariant produktu.

4. Uszkodzone opakowanie — stan pudełka lub opakowania również ma znaczenie, szczególnie jeśli zamawiasz produkt na prezent lub jako przedmiot kolekcjonerski. Zniszczone opakowanie może świadczyć o nieodpowiednim przechowywaniu.

5. Brakujące elementy — jeśli produkt powinien zawierać dodatkowe akcesoria (sznurówki, pokrowce, metki), upewnij się, że są one widoczne na zdjęciach QC. Ich brak może oznaczać, że produkt jest niekompletny.`,
  },
  {
    title: 'Jak poprosić o dodatkowe zdjęcia QC',
    content: `Standardowe zdjęcia QC mogą nie pokazywać wszystkich detali, które chcesz sprawdzić. Na szczęście większość agentów, w tym Kakobuy, umożliwia zamówienie dodatkowych, bardziej szczegółowych zdjęć. Oto jak to zrobić:

Złóż prośbę przez panel zamówienia — większość platform posiada opcję "Poproś o dodatkowe zdjęcia" w panelu zarządzania zamówieniem. Wybierz tę opcję i określ, jakie konkretnie ujęcia Cię interesują.

Bądź precyzyjny w swoim zapytaniu — zamiast pisać "proszę o więcej zdjęć", napisz konkretnie: "Proszę o zbliżenie na logo na języku buta", "Proszę o zdjęcie wewnętrznej metki z rozmiarem", lub "Proszę o zdjęcie podeszwy pod światło". Im bardziej precyzyjne zapytanie, tym większa szansa na otrzymanie użytecznych zdjęć.

Korzystaj z notatek do zamówienia — przy składaniu zamówienia możesz dodać notatkę z wyprzedzeniem, np. "Proszę o szczegółowe zdjęcia wszystkich logo i metek". Agent wykona je automatycznie podczas standardowej sesji QC.

Pamiętaj o czasie — dodatkowe zdjęcia wydłużają czas przetwarzania zamówienia o 12-24 godziny. Uwzględnij to w swoim harmonogramie, szczególnie jeśli zależy Ci na szybkiej wysyłce.

Nie bój się odrzucić produktu — jeśli dodatkowe zdjęcia potwierdzą Twoje obawy, masz prawo poprosić o wymianę lub zwrot. To standardowa procedura i agenci są do niej przyzwyczajeni.`,
  },
  {
    title: 'Zdjęcia QC na Kakobuy vs inne platformy',
    content: `Jakość zdjęć QC różni się w zależności od platformy. Oto porównanie standardów zdjęć QC na najpopularniejszych platformach:

Kakobuy oferuje darmowe zdjęcia QC w przyzwoitej rozdzielczości, pokazujące produkt z przodu, z tyłu, z boku oraz zbliżenie na logo. Zdjęcia są wykonywane przy standardowym oświetleniu i pozwalają na podstawową ocenę jakości. Dodatkowe ujęcia można zamówić za niewielką opłatą.

Pandabuy zapewnia zdjęcia QC w wysokiej rozdzielczości z możliwością powiększenia. Standardowy pakiet obejmuje 4-6 zdjęć z różnych kątów, a dodatkowe ujęcia — w tym zdjęcia w świetle UV i z miarką — są dostępne na życzenie.

Niezależnie od platformy, to Ty jako kupujący jesteś odpowiedzialny za dokładną analizę zdjęć. Nawet najlepsze zdjęcia QC nie zastąpią Twojej uwagi i staranności. Zawsze sprawdzaj każdy detal, porównuj ze zdjęciami sprzedawcy i nie wahaj się prosić o dodatkowe informacje, jeśli masz jakiekolwiek wątpliwości.`,
  },
];

const qcChecklist = [
  ['Szwy i wykończenie', 'Równe, proste, bez luźnych nitek'],
  ['Logo i oznaczenia', 'Prawidłowe umiejscowienie i jakość'],
  ['Kolor', 'Zgodność ze zdjęciami sprzedawcy'],
  ['Materiał', 'Jakość i faktura zgodna z opisem'],
  ['Rozmiar / wymiary', 'Zgodność z tabelą rozmiarów'],
  ['Opakowanie', 'Stan pudełka i akcesoriów'],
  ['Dodatkowe elementy', 'Kompletność produktu'],
];

const articleSchema = getArticleSchema(
  'Jak czytać zdjęcia QC na Kakobuy – Kompletny poradnik dla kupujących 2026',
  'Naucz się analizować zdjęcia kontroli jakości jak profesjonalista. Uniknij złych zakupów i podejmuj świadome decyzje.',
  'https://kakobuyfinds.fit/artykul/jak-czytac-zdjecia-qc-kakobuy',
  'https://readdy.ai/api/search-image?query=Closeup%20macro%20photography%20of%20fabric%20texture%20and%20stitching%20details%20under%20bright%20inspection%20light%2C%20product%20quality%20control%20scene%20with%20magnifying%20glass%20on%20white%20desk%2C%20clean%20professional%20workspace%2C%20bright%20neutral%20lighting%20revealing%20every%20thread%20detail%2C%20editorial%20product%20inspection%20photography%2C%20crisp%20sharp%20focus%20on%20material%20quality&width=1200&height=675&seq=article-qc-01&orientation=landscape',
  '2026-03-10',
  '2026-07-20',
  'Poradnik',
);

const breadcrumbSchema = getBreadcrumbSchema([
  { name: 'Strona główna', url: 'https://kakobuyfinds.fit/' },
  { name: 'Jak czytać zdjęcia QC na Kakobuy', url: 'https://kakobuyfinds.fit/artykul/jak-czytac-zdjecia-qc-kakobuy' },
]);

export default function JakCzytacQC() {
  return (
    <>
      <Navbar />
      <main className="pt-24 pb-16">
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(articleSchema) }} />
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }} />
        <article className="max-w-4xl mx-auto px-4 md:px-6">
          <nav className="text-xs text-foreground-400 mb-8" aria-label="Breadcrumb">
            <Link to="/" className="hover:text-primary-500 transition-colors cursor-pointer">Strona główna</Link>
            <span className="mx-2">/</span>
            <span className="text-foreground-600">Jak czytać zdjęcia QC na Kakobuy</span>
          </nav>

          <header className="mb-12">
            <span className="inline-block bg-accent-100 text-accent-800 text-xs font-semibold px-3 py-1 rounded-full mb-4">
              Poradnik
            </span>
            <h1 className="font-heading text-2xl md:text-4xl lg:text-5xl font-bold text-foreground-900 leading-tight mb-4">
              Jak czytać zdjęcia QC na Kakobuy – Kompletny poradnik dla kupujących 2026
            </h1>
            <p className="text-foreground-500 text-sm md:text-base">
              Naucz się analizować zdjęcia kontroli jakości jak profesjonalista. Uniknij złych zakupów i podejmuj świadome decyzje.
            </p>
          </header>

          <div className="aspect-[16/9] rounded-2xl overflow-hidden mb-12">
            <img
              src="https://readdy.ai/api/search-image?query=Closeup%20macro%20photography%20of%20fabric%20texture%20and%20stitching%20details%20under%20bright%20inspection%20light%2C%20product%20quality%20control%20scene%20with%20magnifying%20glass%20on%20white%20desk%2C%20clean%20professional%20workspace%2C%20bright%20neutral%20lighting%20revealing%20every%20thread%20detail%2C%20editorial%20product%20inspection%20photography%2C%20crisp%20sharp%20focus%20on%20material%20quality&width=1200&height=675&seq=article-qc-01&orientation=landscape"
              alt="Jak czytać zdjęcia QC na Kakobuy - poradnik 2026"
              title="Jak czytać zdjęcia QC na Kakobuy"
              className="w-full h-full object-cover"
            />
          </div>

          <section className="mb-10">
            <h2 className="font-heading text-xl md:text-2xl font-semibold text-foreground-900 mb-4">
              Lista kontrolna QC — co sprawdzać
            </h2>
            <div className="overflow-x-auto rounded-xl border border-background-200/70">
              <table className="w-full text-sm">
                <thead>
                  <tr className="bg-background-100">
                    <th className="text-left px-4 py-3 font-semibold text-foreground-900">Element do sprawdzenia</th>
                    <th className="text-left px-4 py-3 font-semibold text-foreground-900">Na co zwrócić uwagę</th>
                  </tr>
                </thead>
                <tbody>
                  {qcChecklist.map((row, i) => (
                    <tr key={i} className={i % 2 === 0 ? 'bg-background-50' : 'bg-background-100/50'}>
                      <td className="px-4 py-3 font-medium text-foreground-900">{row[0]}</td>
                      <td className="px-4 py-3 text-foreground-600">{row[1]}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </section>

          {articleSections.map((section, i) => (
            <section key={i} className="mb-10">
              <h2 className="font-heading text-xl md:text-2xl font-semibold text-foreground-900 mb-4">
                {section.title}
              </h2>
              {section.content.split('\n\n').map((paragraph, j) => (
                <p key={j} className="text-foreground-600 text-sm md:text-base leading-relaxed mb-4">
                  {paragraph}
                </p>
              ))}
            </section>
          ))}

          <div className="bg-accent-50 rounded-2xl p-6 md:p-8 mb-10">
            <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-3">
              Chcesz podejmować lepsze decyzje zakupowe?
            </h3>
            <p className="text-foreground-600 text-sm mb-5">
              Skorzystaj z Kakobuy Spreadsheet — znajdź sprawdzone produkty z wysokimi ocenami QC.
            </p>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 bg-primary-500 text-background-50 text-sm font-semibold px-6 py-3 rounded-full hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
            >
              Przejdź do Kakobuy Spreadsheet
              <i className="ri-arrow-right-up-line"></i>
            </a>
          </div>

          <div className="border-t border-background-200/70 pt-8">
            <Link
              to="/"
              className="inline-flex items-center gap-2 text-primary-500 hover:text-primary-600 transition-colors text-sm font-medium cursor-pointer"
            >
              <i className="ri-arrow-left-line"></i>
              Powrót do strony głównej
            </Link>
          </div>
        </article>
      </main>
      <Footer />
    </>
  );
}